/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bifrost/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  DeleteRemoteConnection200,
  ListRemoteConnectionsParams,
  RemoteConnectionServiceRestartRemoteConnectionBody,
  RemoteConnectionServiceTestIpsecConnectivityBody,
  RpcStatus,
  V1ListRemoteConnectionsResponse,
  V1RemoteConnection,
  V1RestartRemoteConnectionResponse,
  V1TestIpsecConnectivityResponse,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Lists remote connections in an organization.
 */
export const listRemoteConnections = (
  organizationId: string,
  workspaceId: string,
  params?: ListRemoteConnectionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListRemoteConnectionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListRemoteConnectionsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: ListRemoteConnectionsParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRemoteConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRemoteConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListRemoteConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRemoteConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRemoteConnectionsQueryKey(organizationId, workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRemoteConnections>>
  > = ({ signal }) =>
    listRemoteConnections(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRemoteConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRemoteConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRemoteConnections>>
>;
export type ListRemoteConnectionsQueryError = AxiosError<RpcStatus>;

export function useListRemoteConnections<
  TData = Awaited<ReturnType<typeof listRemoteConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | ListRemoteConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRemoteConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRemoteConnections>>,
          TError,
          Awaited<ReturnType<typeof listRemoteConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRemoteConnections<
  TData = Awaited<ReturnType<typeof listRemoteConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListRemoteConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRemoteConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRemoteConnections>>,
          TError,
          Awaited<ReturnType<typeof listRemoteConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRemoteConnections<
  TData = Awaited<ReturnType<typeof listRemoteConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListRemoteConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRemoteConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists remote connections in an organization.
 */

export function useListRemoteConnections<
  TData = Awaited<ReturnType<typeof listRemoteConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListRemoteConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRemoteConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListRemoteConnectionsQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new remote connection.
 */
export const createRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  v1RemoteConnection: NonReadonly<V1RemoteConnection>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoteConnection>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections`,
    v1RemoteConnection,
    options,
  );
};

export const getCreateRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRemoteConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: NonReadonly<V1RemoteConnection>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: NonReadonly<V1RemoteConnection>;
  },
  TContext
> => {
  const mutationKey = ['createRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRemoteConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      data: NonReadonly<V1RemoteConnection>;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return createRemoteConnection(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRemoteConnection>>
>;
export type CreateRemoteConnectionMutationBody =
  NonReadonly<V1RemoteConnection>;
export type CreateRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new remote connection.
 */
export const useCreateRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRemoteConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: NonReadonly<V1RemoteConnection>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: NonReadonly<V1RemoteConnection>;
  },
  TContext
> => {
  const mutationOptions = getCreateRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a specific remote connection.
 */
export const getRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoteConnection>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections/${id}`,
    options,
  );
};

export const getGetRemoteConnectionQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  id?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections/${id}`,
  ] as const;
};

export const getGetRemoteConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getRemoteConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRemoteConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRemoteConnectionQueryKey(organizationId, workspaceId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRemoteConnection>>
  > = ({ signal }) =>
    getRemoteConnection(organizationId, workspaceId, id, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && id),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRemoteConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRemoteConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRemoteConnection>>
>;
export type GetRemoteConnectionQueryError = AxiosError<RpcStatus>;

export function useGetRemoteConnection<
  TData = Awaited<ReturnType<typeof getRemoteConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRemoteConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteConnection>>,
          TError,
          Awaited<ReturnType<typeof getRemoteConnection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRemoteConnection<
  TData = Awaited<ReturnType<typeof getRemoteConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRemoteConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteConnection>>,
          TError,
          Awaited<ReturnType<typeof getRemoteConnection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRemoteConnection<
  TData = Awaited<ReturnType<typeof getRemoteConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRemoteConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a specific remote connection.
 */

export function useGetRemoteConnection<
  TData = Awaited<ReturnType<typeof getRemoteConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRemoteConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRemoteConnectionQueryOptions(
    organizationId,
    workspaceId,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a remote connection.
 */
export const deleteRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteRemoteConnection200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections/${id}`,
    options,
  );
};

export const getDeleteRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRemoteConnection>>,
    TError,
    { organizationId: string; workspaceId: string; id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRemoteConnection>>,
  TError,
  { organizationId: string; workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['deleteRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRemoteConnection>>,
    { organizationId: string; workspaceId: string; id: string }
  > = props => {
    const { organizationId, workspaceId, id } = props ?? {};

    return deleteRemoteConnection(
      organizationId,
      workspaceId,
      id,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRemoteConnection>>
>;

export type DeleteRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a remote connection.
 */
export const useDeleteRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRemoteConnection>>,
      TError,
      { organizationId: string; workspaceId: string; id: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRemoteConnection>>,
  TError,
  { organizationId: string; workspaceId: string; id: string },
  TContext
> => {
  const mutationOptions = getDeleteRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing remote connection.
 */
export const updateRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  id: string,
  v1RemoteConnection: NonReadonly<V1RemoteConnection>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoteConnection>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections/${id}`,
    v1RemoteConnection,
    options,
  );
};

export const getUpdateRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRemoteConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: NonReadonly<V1RemoteConnection>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: NonReadonly<V1RemoteConnection>;
  },
  TContext
> => {
  const mutationKey = ['updateRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRemoteConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: NonReadonly<V1RemoteConnection>;
    }
  > = props => {
    const { organizationId, workspaceId, id, data } = props ?? {};

    return updateRemoteConnection(
      organizationId,
      workspaceId,
      id,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRemoteConnection>>
>;
export type UpdateRemoteConnectionMutationBody =
  NonReadonly<V1RemoteConnection>;
export type UpdateRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an existing remote connection.
 */
export const useUpdateRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRemoteConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        data: NonReadonly<V1RemoteConnection>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: NonReadonly<V1RemoteConnection>;
  },
  TContext
> => {
  const mutationOptions = getUpdateRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The id goes in the body: Envoy's transcoder does not match a custom verb
following a path variable, so `remoteConnections/{id}:restart...` is
unreachable over REST.
 * @summary Restarts a remote connection's gateway, forcing the IPsec tunnel to
re-negotiate. Does not change the connection's configuration.
 */
export const restartRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  remoteConnectionServiceRestartRemoteConnectionBody: RemoteConnectionServiceRestartRemoteConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestartRemoteConnectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections:restartRemoteConnection`,
    remoteConnectionServiceRestartRemoteConnectionBody,
    options,
  );
};

export const getRestartRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restartRemoteConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: RemoteConnectionServiceRestartRemoteConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restartRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: RemoteConnectionServiceRestartRemoteConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['restartRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restartRemoteConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      data: RemoteConnectionServiceRestartRemoteConnectionBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return restartRemoteConnection(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RestartRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof restartRemoteConnection>>
>;
export type RestartRemoteConnectionMutationBody =
  RemoteConnectionServiceRestartRemoteConnectionBody;
export type RestartRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Restarts a remote connection's gateway, forcing the IPsec tunnel to
re-negotiate. Does not change the connection's configuration.
 */
export const useRestartRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restartRemoteConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: RemoteConnectionServiceRestartRemoteConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restartRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: RemoteConnectionServiceRestartRemoteConnectionBody;
  },
  TContext
> => {
  const mutationOptions = getRestartRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Tests IPsec connectivity for validation before creating a remote connection.
 */
export const testIpsecConnectivity = (
  organizationId: string,
  workspaceId: string,
  remoteConnectionServiceTestIpsecConnectivityBody: RemoteConnectionServiceTestIpsecConnectivityBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TestIpsecConnectivityResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/remoteConnections:testIpsecConnectivity`,
    remoteConnectionServiceTestIpsecConnectivityBody,
    options,
  );
};

export const getTestIpsecConnectivityMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testIpsecConnectivity>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: RemoteConnectionServiceTestIpsecConnectivityBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testIpsecConnectivity>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: RemoteConnectionServiceTestIpsecConnectivityBody;
  },
  TContext
> => {
  const mutationKey = ['testIpsecConnectivity'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testIpsecConnectivity>>,
    {
      organizationId: string;
      workspaceId: string;
      data: RemoteConnectionServiceTestIpsecConnectivityBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return testIpsecConnectivity(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TestIpsecConnectivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof testIpsecConnectivity>>
>;
export type TestIpsecConnectivityMutationBody =
  RemoteConnectionServiceTestIpsecConnectivityBody;
export type TestIpsecConnectivityMutationError = AxiosError<RpcStatus>;

/**
 * @summary Tests IPsec connectivity for validation before creating a remote connection.
 */
export const useTestIpsecConnectivity = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testIpsecConnectivity>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: RemoteConnectionServiceTestIpsecConnectivityBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof testIpsecConnectivity>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: RemoteConnectionServiceTestIpsecConnectivityBody;
  },
  TContext
> => {
  const mutationOptions = getTestIpsecConnectivityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
